<template>
  <section class="relevant">
    <div class="container">
      <a-typography-title :level="1">
        {{ name || '相关内容' }}
      </a-typography-title>
      <a-row :gutter="[50,20]">
        <a-col v-for="(item,index) in expand.showList"
               :xs="24" :md="12" :xl="8">
          <div class="item" :class="`i_${index+1}`">
            <div class="image">
              <img alt=""
                   :src="item.image" />
            </div>
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
            <a v-if="item.button.click" class="button_n_2"
               @click="item.button.click">
              {{ item.button?.name || '查看详情' }}
              <ArrowRightOutlined />
            </a>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import {
  ArrowRightOutlined
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import RelevantProduct_1 from '@resource/image/page/public/relevant_product_1.png';
import RelevantProduct_2 from '@resource/image/page/public/relevant_product_2.png';
import RelevantProduct_3 from '@resource/image/page/public/relevant_product_3.png';
import RelevantPlan_1 from '@resource/image/page/public/relevant_plan_1.png';
import RelevantPlan_2 from '@resource/image/page/public/relevant_plan_2.png';
import RelevantPlan_3 from '@resource/image/page/public/relevant_plan_3.png';
import RelevantNews_1 from '@resource/image/page/public/relevant_news_1.png';
import RelevantBook_1 from '@resource/image/page/public/relevant_book_1.png';
import RelevantBook_2 from '@resource/image/page/public/relevant_book_2.png';
import RelevantOther_1 from '@resource/image/page/public/relevant_other_1.png';
import RelevantOther_2 from '@resource/image/page/public/relevant_other_2.png';

export default {
  name: 'page_relevant',
  components: {
    ArrowRightOutlined
  },
  props: [
    'name',
    'list'
  ],
  data(): DataInterface {
    return {
      expand: {
        list: [
          // 产品
          {
            key: 'product_1',
            title: '云原生智能运维平台SchedulX',
            text: '具备先进Serverless能力的智能运维平台，通过全自动化部署发布、性能维护、稳定性治理，减少90%以上的运维工作，整体IT成本节省可达60%以上。',
            image: RelevantProduct_1,
            button: {
              click: () => {
                this.$router.push($Enum.RouterEnum.ProductSchedulX);
              }
            }
          },
          {
            key: 'product_2',
            title: '一站式企业云成本管家CostPilot',
            text: '通过对成本的深入洞察，快速生成成本报告，并从多种角度提供定制化成本优化建议，以及一体化的优化功能。',
            image: RelevantProduct_2,
            button: {
              click: () => {
                this.$router.push($Enum.RouterEnum.ProductCostPilot);
              }
            }
          },
          {
            key: 'product_3',
            title: '通用Serverless平台InfraPilot',
            text: '免运维、高可用、按需付费的弹性算力调度平台，帮助各类Web系统零改造实现Serverless化。',
            image: RelevantProduct_3,
            button: {
              click: () => {
                this.$router.push($Enum.RouterEnum.ProductInfraPilot);
              }
            }
          },
          
          // 解决方案
          {
            key: 'plan_1',
            title: '智能运维解决方案',
            text: '基于业务指标精准度量、算力极速调度等核心能力，实现自动化智能运维，降低运维操作门槛，助力企业提升运维效率高达10倍。',
            image: RelevantPlan_1,
            button: {
              click: () => {
                this.$router.push($Enum.RouterEnum.PlanOperation);
              }
            }
          },
          {
            key: 'plan_2',
            title: '成本优化解决方案',
            text: '提供深入成本洞察、精细化算力治理，在维持业务稳定性的前提下，帮助企业降低IT成本高达50%。',
            image: RelevantPlan_2,
            button: {
              click: () => {
                this.$router.push($Enum.RouterEnum.PlanCost);
              }
            }
          },
          {
            key: 'plan_3',
            title: '东数西算解决方案',
            text: '支持将对网络要求不高的业务数据传输至西部数据中心，减少数据中心投资运营成本，提升数据中心整体效率，更好地赋能业务数字化发展。',
            image: RelevantPlan_3,
            button: {
              click: () => {
                this.$router.push($Enum.RouterEnum.PlanMigrate);
              }
            }
          },
          
          // 新闻
          {
            key: 'news_1',
            title: '重磅揭秘！10分钟10TB数据跨云跨地域传输的技术实践',
            text: '本文详细解读基于云原生技术的海量数据搬迁技术。',
            image: RelevantNews_1,
            button: {
              click: () => {
                this.$router.push(`${ $Enum.RouterEnum.NewsDetail }?id=47570340863279106`);
              }
            }
          },
          
          // 白皮书
          {
            key: 'book_1',
            title: '成本优化白皮书',
            text: '以运维负责人视角全面阐释IT资源降本增效的方法，分阶段步骤实现最多70%的成本节省。',
            image: RelevantBook_1,
            button: {
              name: '免费领取',
              click: () => {
                open(($ENV.isProduction ? '' : '/#') + $Enum.RouterEnum.BookCostOptimization);
              }
            }
          },
          {
            key: 'book_2',
            title: '智能运维解决方案白皮书',
            text: '提供云原生时代的新一代 DevOps 工具全景图，打造适配不同体量、不同阶段企业的工程效能及智能运维综合解决方案。',
            image: RelevantBook_2,
            button: {
              click: () => {
                open(($ENV.isProduction ? '' : '/#') + $Enum.RouterEnum.BookDevOps);
              }
            }
          },
          
          // 其他
          {
            key: 'other_1',
            title: 'SchedulX 版本更新',
            text: '在原有快速压测、对象存储、集成管理等功能基础上，新增K8s成本拆分、ECS规格压测、成本周报、成本预算和体检等功能。',
            image: RelevantOther_1,
            button: {
              click: () => {
                open('https://mp.weixin.qq.com/s/IHsQWsdQeK36T3OkntO5pw');
              }
            }
          },
          {
            key: 'other_2',
            title: 'Serverless解决方案',
            text: '无需关注基础设施或业务容量，便可实现快速部署、按需申请资源等。您只需关注业务开发，实现更高业务价值。',
            image: RelevantOther_2,
            button: {
              blank: false,
              click: () => {
                $Store.Page().openModal('modalFormCollection', 'learnMore');
              }
            }
          }
        ],
        showList: []
      }
    };
  },
  mounted(): void {
    this.initList();
  },
  methods: {
    /**
     * 初始化列表
     */
    initList(): void {
      this.expand.showList = [];
      this.list.forEach((v: string) => {
        this.expand.showList.push(this.expand.list.find(vv => vv.key === v));
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productSchedulX/';

.relevant {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 60px;
  @style: transform @time, box-shadow @time;
  position: relative;
  min-height: 380px;
  padding-bottom: 50px;
  background: @color_white;
  border: 1px solid @color_15;
  .transition(@style);
  
  &:hover {
    .transform(translateY(-5px));
    .shadow(0 15px 25px fade(#6E778B, 20));
  }
  
  .image {
    display: block;
    position: relative;
    height: 150px;
    background: #EEEDF7;
    
    img {
      display: block;
      .position();
      height: 90%;
      margin: auto;
    }
  }
  
  h5.ant-typography {
    padding: 0 30px;
    margin: @margin_mo 0 0;
    .font(center, @text_big+@line, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    //min-height: 78px;
    padding: 0 30px;
    margin: 10px 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
  
  .button_n_2 {
    .position(bottom, 10px);
    margin: 0 auto;
    border: none !important;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .relevant {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    min-height: auto;
    
    h5.ant-typography {
      margin: @margin_mo 0 0;
      .font(center, @text_big_mo+@line_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      min-height: auto;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
    
    .button_n_2 {
      bottom: 5px;
    }
  }
}
</style>